import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=53e40f7c&scoped=true&"
import script from "./Secure.vue?vue&type=script&lang=js&"
export * from "./Secure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e40f7c",
  null
  
)

export default component.exports